export default __webpack_public_path__ + "static/media/map-creator.5d42a9f1.png";